/** Identifies the focus an event is about. Every Unit Focus event carries this context. */
export interface UnitFocusEventContext {
  /** Ids of the classes selected for the action. */
  classIds: readonly string[];
  /** Id of the selected unit. */
  targetId: string;
  /** Id of the selected roadmap. */
  targetGroupId: string;
  /** Value of the "Other units blocked" setting. */
  blockingEnabled: boolean;
}

/** The context as PostHog receives it: snake_case keys, plain mutable values. */
export interface UnitFocusEventProperties {
  class_id: string[];
  target_id: string;
  target_group_id: string;
  blocking_enabled: boolean;
}

export function buildUnitFocusEventProperties(context: UnitFocusEventContext): UnitFocusEventProperties {
  return {
    // Copied because PostHog's property type doesn't accept readonly arrays.
    class_id: [...context.classIds],
    target_id: context.targetId,
    target_group_id: context.targetGroupId,
    blocking_enabled: context.blockingEnabled,
  };
}
